/**
 * @file index.ts
 * @description Индексный файл отчетов системы управления задачами.
 * Экспортирует конфигурации для генерации и отображения отчетов по спринтам.
 * Определяет интерфейс IEntityData для структуры данных отчетов
 * с настройками поиска, фильтрации и колонок для табличного представления.
 * Централизует конфигурацию всех типов отчетов в системе.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies []
 * @related-files [./sprint.tsx]
 */

import { IReportPage } from '@src/types/page';
import * as sprint from './sprint';

const items: IReportPage[] = [sprint];

export default items;
